// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_material-ui_icons_RemoveCircle_js-node_modules_react-quill_dist_quill_sn-e079a1":"3fbd30fb13cc98951685","front_react_features_challenges_src_Challenges_hook_component_tsx-node_modules_brainhubeu_rea-fa676f":"7bf1acd8602799e777bd"}[chunkId] + ".css";
};